import getConfig from "@/utils/getConfig";
import {OverwolfApi, OWGame} from "@devour/client";
import {useQuery} from "@tanstack/react-query";

async function fetchOverwolfGameInfo(gameId: string): Promise<OWGame> {
    return await new OverwolfApi(getConfig()).getOverwolfGame({
        id: gameId,
    });
}

function useGetOverwolfGameInfoQuery(gameId: string) {
    return {
        queryKey: [
            "overwolf-game-info",
            gameId,
        ],
        queryFn: () => gameId ? fetchOverwolfGameInfo(gameId) : null,
        /*
         * Game info is static reference data - WebSocket updates will invalidate cache when game info changes
         * This prevents unnecessary API calls while still providing real-time updates through WebSocket
         */
        staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days (down from 30 days, fixed typo)
        gcTime: 14 * 24 * 60 * 60 * 1000, // 14 days in cache
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        enabled: !!gameId,
    } as const;
}

export default function useGetOverwolfGameInfo(gameId: string) {
    return useQuery<OWGame>(useGetOverwolfGameInfoQuery(gameId));
}
